import { Box, Text, Carousel, Image } from 'grommet';
import { FrostedGlassBox } from '../components';


const GallerySection = ({ imageList }) => {

  return (
    <FrostedGlassBox width={'40.4rem'}>
      <div class="container" >
        <Box height={{ height: `${window?.innerWidth ? window?.innerWidth * 0.6333 : 200}px`, max: '25.332rem' }} width={{ max: "53rem", width: "100%" }} overflow="hidden">
          {imageList && imageList?.length > 0 ?
            (
              <Carousel fill wrap style={{ animation: '100ms' }} controls='arrows'>
                {
                  imageList.map(i => {
                    return (
                      <Image fit="cover" src={i} />
                    )
                  })
                }
              </Carousel>
            )
            :
            (
              <Text alignSelf="center" margin={'auto'}>No image is available for this property.</Text>
            )
          }

        </Box>
      </div>
    </FrostedGlassBox>
  );
};

export { GallerySection }